
export const name = "ecosystem-marketplace-apps-app-ui";
export const version = "dev";
